
<!-- <h3 class="text-xs-center text-md-left">Teaching</h3> -->


<h5 class="p-3 mb-2 bg-dark text-light">Instructor</h5>
<h4 class="card-title">
    Econ 353, Labor Economics <i class="medium-font">, University of Wisconsin-Whitewater (Fall 2025)</i>
</h4>
<h4 class="card-title">
    Econ 201, Principles of Microeconomics <i class="medium-font">, University of Wisconsin-Whitewater (Fall 2024, Spring 2025, Fall 2025)</i>
</h4>
<h4 class="card-title">
    Econ 490: Behavioral Economics <i class="medium-font">, University of Illinois, Urbana Champaign (Spring 2022, Fall 2022, Spring 2023, Fall 2023 )</i>
</h4>
<div class="row">
    <div class="col-md-1">
        <h5><a href="../../../assets/teaching/Syllabus_Econ 490_BE_Fall 2022.pdf" target="_blank" class="btn badge badge-primary course-buttons">Syllabus</a></h5>
        
    </div>
    <div class="col-md-1">
        <h5><a href="../../../assets/teaching/Eval Econ 490.pdf" target="_blank" class="btn badge badge-primary course-buttons">Evaluation</a></h5>
        
    </div>
    
</div>
<hr>
<h4 class="card-title">
    Econ 471: Introduction to Applied Econometrics <i class="medium-font">, University of Illinois, Urbana Champaign (Fall 2021) </i>
</h4>
<div class="row">
    <div class="col-md-1">
        <h5><a href="../../../assets/teaching/Syllabus_Econ 471_Fall 2021.pdf" target="_blank" class="btn badge badge-primary course-buttons">Syllabus</a></h5>
        
    </div>
    <div class="col-md-1">
        <h5><a href="../../../assets/teaching/Eval Econ 471.pdf" target="_blank" class="btn badge badge-primary course-buttons">Evaluation</a></h5>
        
    </div>
    
</div>
<hr>

<h4 class="card-title">
    Econ 120: Principles of Microeconomics <i class="medium-font">, Kansas State University (Spring 2018)  </i>
</h4>
<hr>
<h4 class="card-title">
    Econ 520: Intermediate Microeconomics <i class="medium-font">, Kansas State University (Fall 2017)  </i>
</h4>

<hr>


<!-- <h5 class="p-3 mb-2 bg-dark text-light">Teaching Assistant</h5>

<h4 class="card-title">
    Econ 520: Macroeconomics for Business <i class="medium-font">(Summer 2021)</i>
</h4>
<h4 class="card-title">
    Econ 202: Economics Statistics <i class="medium-font">(Fall 2019, Fall 2020, Spring 2021)</i>
</h4>
<h4 class="card-title">
    BADM 590: Fostering Creative Thinking <i class="medium-font">(Summer 2019)</i>
</h4> -->
<!-- <h4 class="card-title">
    Econ 720: Microeconomics I Graduate course <i class="medium-font">(Spring 2017)</i>
</h4>
<h4 class="card-title">
    Econ 682: Development Economics <i class="medium-font">(Fall 2016)</i>
</h4> -->




